module.exports = __webpack_public_path__ + "assets/img/modal-avatar-0c91e78c.png";